/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_FilesInputs */

const id_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File yang diindeks`)
};

const ms_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail diindeks`)
};

const da_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indekserede filer`)
};

const de_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indizierte Dateien`)
};

const en_us2_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files indexed`)
};

const es_es2_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos indexados`)
};

const es_mx2_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos indexados`)
};

const fil_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga naka-index na file`)
};

const fr_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers indexés`)
};

const it_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File indicizzati`)
};

const hu_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexelt fájlok`)
};

const nl_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geïndexeerde bestanden`)
};

const no_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indekserte filer`)
};

const pl_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zindeksowane pliki`)
};

const pt_br2_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivos indexados`)
};

const pt_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiros indexados`)
};

const ro_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fișiere indexate`)
};

const fi_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indeksoidut tiedostot`)
};

const sv_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexerade filer`)
};

const vi_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp đã lập chỉ mục`)
};

const tr_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizine eklenen dosyalar`)
};

const cs_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexované soubory`)
};

const bg_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индексирани файлове`)
};

const ru_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проиндексированные файлы`)
};

const uk_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проіндексовані файли`)
};

const ar_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملفات المفهرسة`)
};

const hi_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुक्रमित फ़ाइलें`)
};

const th_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์ที่ทำดัชนีแล้ว`)
};

const ja_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インデックス済みファイル`)
};

const zh_cn2_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已索引文件`)
};

const zh_hant1_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已編索檔案`)
};

const ko_builds_header_files = /** @type {(inputs: Builds_Header_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`색인된 파일`)
};

/**
* | output |
* | --- |
* | "Files indexed" |
*
* @param {Builds_Header_FilesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_files = /** @type {((inputs?: Builds_Header_FilesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_FilesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_files(inputs)
	if (locale === "ms") return ms_builds_header_files(inputs)
	if (locale === "da") return da_builds_header_files(inputs)
	if (locale === "de") return de_builds_header_files(inputs)
	if (locale === "en-US") return en_us2_builds_header_files(inputs)
	if (locale === "es-ES") return es_es2_builds_header_files(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_files(inputs)
	if (locale === "fil") return fil_builds_header_files(inputs)
	if (locale === "fr") return fr_builds_header_files(inputs)
	if (locale === "it") return it_builds_header_files(inputs)
	if (locale === "hu") return hu_builds_header_files(inputs)
	if (locale === "nl") return nl_builds_header_files(inputs)
	if (locale === "no") return no_builds_header_files(inputs)
	if (locale === "pl") return pl_builds_header_files(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_files(inputs)
	if (locale === "pt") return pt_builds_header_files(inputs)
	if (locale === "ro") return ro_builds_header_files(inputs)
	if (locale === "fi") return fi_builds_header_files(inputs)
	if (locale === "sv") return sv_builds_header_files(inputs)
	if (locale === "vi") return vi_builds_header_files(inputs)
	if (locale === "tr") return tr_builds_header_files(inputs)
	if (locale === "cs") return cs_builds_header_files(inputs)
	if (locale === "bg") return bg_builds_header_files(inputs)
	if (locale === "ru") return ru_builds_header_files(inputs)
	if (locale === "uk") return uk_builds_header_files(inputs)
	if (locale === "ar") return ar_builds_header_files(inputs)
	if (locale === "hi") return hi_builds_header_files(inputs)
	if (locale === "th") return th_builds_header_files(inputs)
	if (locale === "ja") return ja_builds_header_files(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_files(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_files(inputs)
	return ko_builds_header_files(inputs)
});
export { builds_header_files as "builds.header.files" }